import { ProblemData } from "../../MathFactsGenerator/Constants.ts";

export type AnswerResult = "correct" | "wrong" | "skipped";

/** The number a typed answer is checked against. */
export function expectedAnswer(problem: ProblemData): number {
    return problem.numbers[2];
}

/**
 * Whether this problem carries a remainder a single answer box cannot hold.
 * Out of scope for the quiz (ADR 0003); flash-card quiz settings never turn
 * remainders on, so this is a guard rather than a live path.
 */
function hasRemainder(problem: ProblemData): boolean {
    return problem.numbers.length > 3 && problem.numbers[3] > 0;
}

/**
 * Marks a typed answer.
 *
 * An empty box is a skip, not a wrong answer: "I didn't know" and "I got it
 * wrong" are different things to tell a child about what they know, and the
 * summary should not accuse them of the second. Anything that is not a whole
 * number is wrong; a leading zero ("07") is not.
 */
export function checkAnswer(problem: ProblemData, typed: string): AnswerResult {
    const trimmed = typed.trim();
    if (trimmed === "") {
        return "skipped";
    }
    if (!/^\d+$/.test(trimmed) || hasRemainder(problem)) {
        return "wrong";
    }
    return Number(trimmed) === expectedAnswer(problem) ? "correct" : "wrong";
}
